<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店进销存管理</el-breadcrumb-item>
      <el-breadcrumb-item>采购管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.leibie" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianChanPingLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.guige" @keyup.enter.native="clicksearch" placeholder="请输入规格/型号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <TencentyunCosUploadExcel v-if="SubRule_MenDianPurchaseSalesJinXiao_Add" @change="changeTencentyunCosUploadExcel" ></TencentyunCosUploadExcel>
            注意：此处是新增导入
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
          <el-table-column prop="Riqi" label="日期" min-width="10%"></el-table-column>
          <el-table-column prop="Leibie" label="类别" min-width="10%"></el-table-column>
          <el-table-column prop="Name" label="名称" min-width="10%"></el-table-column>
          <el-table-column prop="Guige" label="规格/型号" min-width="10%"></el-table-column>
          <el-table-column prop="Stockindanjia" label="采购单价" min-width="8%"></el-table-column>
          <el-table-column prop="Dlsdanjia" label="代理商单价" min-width="9%"></el-table-column>
          <el-table-column prop="Saledanjia" label="建议零售单价" min-width="8%"></el-table-column>
          <el-table-column prop="Num" label="采购数量" min-width="8%"></el-table-column>
          <el-table-column prop="Stockinamount" label="采购金额" min-width="8%"></el-table-column>
          <el-table-column prop="Dlsamount" label="代理商金额" min-width="9%"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_MenDianPurchaseSalesJinXiao_Edit" @click="goModifyDeviceInformation(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_MenDianPurchaseSalesJinXiao_Delete" @click="clickDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" v-if="SubRule_MenDianPurchaseSalesJinXiao_Add">
        <el-form :model="addForm" ref="addFormRef" label-width="90px">
          <el-form-item label="归属机构" class="addAdminForm">
            <el-select v-model="addForm.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" class="addAdminForm">
            <el-date-picker v-model="addForm.riqi" type="date" placeholder="日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="类别" class="addAdminForm">
            <el-select v-model="addForm.leibie" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianChanPingLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" class="addAdminForm">
            <el-input v-model="addForm.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="规格/型号" class="addAdminForm">
            <el-input v-model="addForm.guige" placeholder="请输入规格/型号"></el-input>
          </el-form-item>
          <el-form-item label="采购单价" class="addAdminForm">
            <el-input v-model="addForm.stockindanjia" placeholder="请输入采购单价" @input="processAmount()"></el-input>
          </el-form-item>
          <el-form-item label="代理商单价" class="addAdminForm">
            <el-input v-model="addForm.dlsdanjia" placeholder="请输入代理商单价" @input="processAmount()"></el-input>
          </el-form-item>
          <el-form-item label="建议零售单价" class="addAdminForm">
            <el-input v-model="addForm.saledanjia" placeholder="请输入建议零售单价"></el-input>
          </el-form-item>
          <el-form-item label="采购数量" class="addAdminForm">
            <el-input v-model="addForm.num" placeholder="请输入采购数量" @input="processAmount()"></el-input>
          </el-form-item>
          <el-form-item label="采购金额" class="addAdminForm">
            <el-input v-model="addForm.stockinamount" placeholder="请输入采购金额" disabled></el-input>
          </el-form-item>
          <el-form-item label="代理商金额" class="addAdminForm">
            <el-input v-model="addForm.dlsamount" placeholder="请输入代理商金额" disabled></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <MenDianPurchaseSalesJinXiaoEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></MenDianPurchaseSalesJinXiaoEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import MenDianPurchaseSalesJinXiaoEdit from '@/componentsSubVue/MenDianPurchaseSalesJinXiaoEdit.vue'
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    MenDianPurchaseSalesJinXiaoEdit,
    TencentyunCosUploadExcel
  },
  name: 'MyMenDianPurchaseSalesJinXiao',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        jigouid: '-1',
        jigouname: '',
        leibie: '',
        name: '',
        guige: '',
        begintime: '',
        endtime: ''
      },
      // 添加
      addForm: {
        jigouid: '-1',
        jigouname: '',
        riqi: '',
        leibie: '',
        name: '',
        guige: '',
        stockindanjia: '0',
        dlsdanjia: '0',
        saledanjia: '0',
        num: '0',
        stockinamount: '0',
        dlsamount: '0'
      },
      SubRule_MenDianPurchaseSalesJinXiao_Add: false,
      SubRule_MenDianPurchaseSalesJinXiao_Edit: false,
      SubRule_MenDianPurchaseSalesJinXiao_Delete: false,
      RuiShiLiYanKeMenDian:[],
      RuiShiLiYanKeMenDianChanPingLeiBie:[],
    }
  },
  mounted () {
    this.RuiShiLiYanKeMenDian = Vue.prototype.FunGetRuiShiLiYanKeMenDian()
    this.RuiShiLiYanKeMenDianChanPingLeiBie = Vue.prototype.FunGetRuiShiLiYanKeMenDianChanPingLeiBie()
    this.apiGetMenDianPurchaseSalesJinXiaoNum()
    this.apiGetMenDianPurchaseSalesJinXiaoList()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesJinXiao_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MenDianPurchaseSalesJinXiao_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesJinXiao_Edit', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MenDianPurchaseSalesJinXiao_Edit = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MenDianPurchaseSalesJinXiao_Delete', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MenDianPurchaseSalesJinXiao_Delete = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetMenDianPurchaseSalesJinXiaoNum()
      this.apiGetMenDianPurchaseSalesJinXiaoList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportMenDianPurchaseSalesJinXiao(url)
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMenDianPurchaseSalesJinXiaoList()
    },
    processAmount (){
      var buf1 = Number(this.addForm.stockindanjia) * Number(this.addForm.num)
      var buf2 = Number(this.addForm.dlsdanjia) * Number(this.addForm.num)
      this.addForm.stockinamount = this.pnum(buf1)
      this.addForm.dlsamount = this.pnum(buf2)
    },
    pnum (num) {
      return Number(Number(num).toFixed(2))
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetMenDianPurchaseSalesJinXiaoNum()
      this.apiGetMenDianPurchaseSalesJinXiaoList()
    },
    clickadd () {
      this.apiAddMenDianPurchaseSalesJinXiao()
    },
    // 修改
    goModifyDeviceInformation (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    clickDelete (row) {
      this.$confirm('是否删除此采购信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteMenDianPurchaseSalesJinXiao(row.Id)
      })
    },
    apiGetMenDianPurchaseSalesJinXiaoList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        name: that.keywords.name,
        guige: that.keywords.guige,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMenDianPurchaseSalesJinXiaoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetMenDianPurchaseSalesJinXiaoNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        name: that.keywords.name,
        guige: that.keywords.guige,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMenDianPurchaseSalesJinXiaoNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMenDianPurchaseSalesJinXiao: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addForm.jigouid,
        riqi: that.addForm.riqi,
        leibie: that.addForm.leibie,
        name: that.addForm.name,
        guige: that.addForm.guige,
        stockindanjia: that.addForm.stockindanjia,
        dlsdanjia: that.addForm.dlsdanjia,
        saledanjia: that.addForm.saledanjia,
        num: that.addForm.num,
        stockinamount: that.addForm.stockinamount,
        dlsamount: that.addForm.dlsamount
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMenDianPurchaseSalesJinXiao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addForm.jigouid = '-1'
            that.addForm.jigouname = ''
            that.addForm.riqi = ''
            that.addForm.leibie = ''
            that.addForm.name = ''
            that.addForm.guige = ''
            that.addForm.stockindanjia = '0'
            that.addForm.dlsdanjia = '0'
            that.addForm.saledanjia = '0'
            that.addForm.num = '0'
            that.addForm.stockinamount = '0'
            that.addForm.dlsamount = '0'

            that.apiGetMenDianPurchaseSalesJinXiaoNum()
            that.apiGetMenDianPurchaseSalesJinXiaoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteMenDianPurchaseSalesJinXiao: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteMenDianPurchaseSalesJinXiao, Qs.stringify(data))
        .then(function (response) {
          that.apiGetMenDianPurchaseSalesJinXiaoNum()
          that.apiGetMenDianPurchaseSalesJinXiaoList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportMenDianPurchaseSalesJinXiao: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportMenDianPurchaseSalesJinXiao, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apiGetMenDianPurchaseSalesJinXiaoNum()
            that.apiGetMenDianPurchaseSalesJinXiaoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
